import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWeb3 } from '../../context/Web3Context';
import { copyToClipboard, formatUSDT } from '../../utils/format';
import { notify } from '../../utils/notify';
import { PLAN_INFO } from '../../config/contract';

const RegisterSuccessModal = ({ open, onClose, plan, amount }) => {
  const { userId } = useWeb3();
  const navigate = useNavigate();

  const planInfo = PLAN_INFO[plan] || PLAN_INFO[0];

  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onEsc);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  const refLink = `${window.location.origin}/invest?ref=${userId || ''}`;

  const copy = async (text, label) => {
    const ok = await copyToClipboard(text);
    if (ok) notify.success(`${label} copied`);
  };

  const goDashboard = () => {
    onClose && onClose();
    navigate('/dashboard');
  };

  return (
    <div className="success-overlay" onClick={onClose}>
      <div className="success-modal" onClick={(e) => e.stopPropagation()}>
        <div className="success-confetti">
          {Array.from({ length: 18 }).map((_, i) => (
            <span
              key={i}
              className="confetti-piece"
              style={{
                left: `${(i * 5.5) % 100}%`,
                animationDelay: `${(i * 0.12) % 2}s`,
                background: [
                  'var(--accent-cyan)', 'var(--accent-green)',
                  'var(--accent-purple)', 'var(--accent-pink)',
                  'var(--accent-orange)'
                ][i % 5]
              }}
            />
          ))}
        </div>

        <div className="success-check-wrap">
          <div className="success-ring success-ring-1" />
          <div className="success-ring success-ring-2" />
          <div className="success-ring success-ring-3" />
          <div className="success-check">
            <svg viewBox="0 0 52 52" width="40" height="40">
              <path
                d="M14 27 L23 36 L40 17"
                fill="none"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="60"
                strokeDashoffset="60"
                style={{ animation: 'drawCheck 0.6s 0.3s ease forwards' }}
              />
            </svg>
          </div>
        </div>

        <div className="success-title">WELCOME ABOARD</div>
        <div className="success-subtitle">
          Your registration was successful. Your staking position is now active on the network.
        </div>

        <div className="success-id-box">
          <div className="success-id-label">YOUR USER ID</div>
          <div className="success-id-value">
            #{userId || '...'}
            {userId ? (
              <button
                className="success-icon-btn"
                onClick={() => copy(String(userId), 'User ID')}
                title="Copy ID"
              >⎘</button>
            ) : null}
          </div>
        </div>

        <div className="success-stats">
          <div className="success-stat">
            <div className="success-stat-label">Tier</div>
            <div className="success-stat-value" style={{ color: planInfo.color }}>
              {planInfo.rank}
            </div>
          </div>
          <div className="success-stat">
            <div className="success-stat-label">Plan</div>
            <div className="success-stat-value">{planInfo.days}d</div>
          </div>
          <div className="success-stat">
            <div className="success-stat-label">Staked</div>
            <div className="success-stat-value">
              {amount ? formatUSDT(amount) : '—'}
            </div>
          </div>
          <div className="success-stat">
            <div className="success-stat-label">Daily ROI</div>
            <div className="success-stat-value text-green">{planInfo.dailyROI}</div>
          </div>
        </div>

        <div className="success-ref-box">
          <div className="success-ref-label">Your Referral Link</div>
          <div className="success-ref-row">
            <div className="success-ref-text">{refLink}</div>
            <button
              className="success-ref-copy"
              onClick={() => copy(refLink, 'Referral link')}
            >Copy</button>
          </div>
        </div>

        <div className="success-actions">
          <button className="btn btn-primary btn-lg btn-block" onClick={goDashboard}>
            Enter Dashboard
          </button>
          <button className="btn btn-ghost btn-sm btn-block" onClick={onClose}>
            Stay on Invest Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterSuccessModal;
